// extracted by mini-css-extract-plugin
export default {"content":"xxX8a","sportContainer":"_1OV2r"};